import { render, staticRenderFns } from "./favorite-sales-items.vue?vue&type=template&id=3f302294"
import script from "./favorite-sales-items.vue?vue&type=script&lang=js"
export * from "./favorite-sales-items.vue?vue&type=script&lang=js"
import style0 from "./favorite-sales-items.vue?vue&type=style&index=0&id=3f302294&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports